module.exports = __webpack_public_path__ + "static/img/moaInstallForMac_pic14.d94a35e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForMac/moaInstallForMac_pic14.png
// module id = 532
// module chunks = 1